"use client";

import { useSession } from "next-auth/react";
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { FieldValues, UseFormSetValue } from "react-hook-form";
import DatePickerElement from "@/app/(main)/(club)/mes-clubs/[id]/components/date-picker-element";
import { isDayAlreadyInvited, useAlreadyInvitedKeys } from "@/app/(main)/(club)/mes-clubs/[id]/utils/already-invited-dates";
import { getAllDaysOfMonth } from "@/app/(main)/(club)/mes-clubs/[id]/utils/utils";
import { getClubEvents } from "@/app/api/dynabuy-back/api-events";
import { getClubEventsFromClient } from "@/app/api/dynabuy-back/client-side-api-events";
import Flash from "@/components/flash";
import ComponentLoading from "@/components/global/component-loading";
import { EventForCalendar } from "@/TS/Interfaces/global_interfaces";
function ChooseEventDatePicker({
  isHere,
  setIsHere,
  clubSlug,
  setValue,
  alreadyInvitedDates
}: {
  clubSlug?: string;
  setIsHere: Dispatch<SetStateAction<boolean>>;
  isHere?: boolean;
  setValue: UseFormSetValue<FieldValues>;
  alreadyInvitedDates?: string[];
}) {
  const [date, setDate] = useState(new Date());
  const alreadyInvitedKeys = useAlreadyInvitedKeys(alreadyInvitedDates);
  const allDaysOfMonth = getAllDaysOfMonth(date);
  const [displayEventArr, setDisplayEventArr] = useState<number[] | undefined>(undefined);
  const [eventArr, setEventArr] = useState<EventForCalendar[]>([]);
  useEffect(() => {
    const fetchData = async () => {
      const firstDayOfMonth = new Date();
      firstDayOfMonth.setUTCDate(1);
      try {
        const events = await getClubEvents(clubSlug!, firstDayOfMonth);
        const arrOfEvents = events.map(elem => ({
          id: elem["@id"],
          date: new Date(elem.startDate!),
          cancel: elem.cancel
        }));
        setEventArr(arrOfEvents);
        setDisplayEventArr(arrOfEvents.map(res => res.date.getDate()));
      } catch {
        setDisplayEventArr([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [clubSlug]);
  const [isLoading, setIsLoading] = useState(false);
  const [cannotLoadEvents, setCannotLoadEvents] = useState(false);
  const user = useSession();
  const token = user?.data?.user?.dynabuyToken;
  const abortControllerRef = useRef<AbortController | null>(null);
  const handleMonthDate = async (increment: number) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const newAbortController = new AbortController();
    abortControllerRef.current = newAbortController;
    setIsLoading(true);
    setCannotLoadEvents(false);
    setDate(prev => {
      return new Date(prev.getFullYear(), prev.getMonth() + increment);
    });
    let currentDate = new Date(date.getFullYear(), date.getMonth() + increment);
    try {
      const events_0 = await getClubEventsFromClient(setIsLoading, token, newAbortController.signal, clubSlug!, 1, currentDate);
      // let nextEvents = events.filter(
      //   (elem) => new Date(elem.startDate) >= new Date(),
      // );
      const arrOfEvents_0 = events_0.map(elem_0 => {
        return {
          id: elem_0["@id"],
          date: new Date(elem_0.startDate!),
          cancel: elem_0.cancel
        };
      });
      setEventArr(arrOfEvents_0);
      setDisplayEventArr(arrOfEvents_0.map(res_0 => res_0.date.getDate()));
    } catch {
      setDisplayEventArr([]);
      setIsLoading(false);
    }
  };
  const handleEvent = (index: number) => {
    if (!displayEventArr!.includes(index)) {
      return;
    }
    if (isDayAlreadyInvited(alreadyInvitedKeys, date, index)) {
      return;
    }
    setValue("dayofmonth", new Date(date.setDate(index)).toLocaleDateString(undefined, {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric"
    }));
    setIsHere(false);
  };
  if (!isHere) return null;
  if (undefined === displayEventArr) return <ComponentLoading label={"Chargement des évènements ..."} />;
  return <>
      {cannotLoadEvents && <Flash type="danger">Impossible de charger les évènements</Flash>}
      <DatePickerElement date={date} handleMonthDate={handleMonthDate} allDaysOfMonth={allDaysOfMonth} isLoading={isLoading} handleEvent={handleEvent} displayEventArr={displayEventArr} eventArr={eventArr} alreadyInvitedDates={alreadyInvitedDates} />
    </>;
}
export default ChooseEventDatePicker;